import FundsInstance from 'modules/funds/repository';

export const getFunds = (page, size, search, filters, sort) => FundsInstance.getFunds({
  page, size, search, filters, sort,
});

export const createFund = (fund) => FundsInstance.postFund({ ...fund }).catch((err) => { throw err; });

export const editFund = (id, fund) => FundsInstance.putFund(id, { ...fund }).catch((err) => { throw err; });

export const deleteFund = (fund) => FundsInstance.deleteFund(fund);
